import FirstName from './FirstName';
import LastName from './LastName';

function FirstNameLastName({ first_name, last_name, initialValues, language }) {
    if (language !== 'jp') {
        return (
            <>
                <FirstName label={first_name} initialValues={initialValues} />
                <LastName label={last_name} initialValues={initialValues} />
            </>
        );
    } else {
        return (
            <>
                <LastName label={last_name} initialValues={initialValues} />
                <FirstName label={first_name} initialValues={initialValues} />
            </>
        );
    }
}
export default FirstNameLastName;
